type TokenGetter = () => Promise<string | null>
type SessionIdGetter = () => string | null

let tokenGetter: TokenGetter | null = null
let sessionIdGetter: SessionIdGetter | null = null

export function setAuthTokenGetter(getter: TokenGetter | null) {
  tokenGetter = getter
}

export function setSessionIdGetter(getter: SessionIdGetter | null) {
  sessionIdGetter = getter
}

export async function getAuthToken(): Promise<string | null> {
  if (!tokenGetter) return null
  return tokenGetter()
}

export function getSessionId(): string | null {
  if (!sessionIdGetter) return null
  return sessionIdGetter()
}
